import { useHomeBanner, useServiceAIAnalyticsAssistant } from '@/src/api/getData';
import Banner from '@/components/banner';
import Card from '@/components/card';
import DynamicContent from '@/components/dynamicContent';

const ITechLearningAnalyticsView: any = ({ language = '' }) => {
    const { data: banner } = useHomeBanner(language);
    const { data: analyticsAssistant } = useServiceAIAnalyticsAssistant(language);
    let analyticsAssistantData = analyticsAssistant?.data || {};

    return (
        <main className='bg-2' id="start">
            <Banner banner={banner} category="AI Learning Analytics Wizard" />
            <Card cardData={analyticsAssistantData?.Card_video?.Cards || []} cardType="orange-card"/>
            <DynamicContent content={analyticsAssistantData?.Content} />
        </main>
    );
}
export default ITechLearningAnalyticsView;